var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, Unique, UpdateDateColumn } from 'typeorm';
import { getLongTextEntityType } from '@/common/config';
let StreamEvent = class StreamEvent {
    id;
    txDigest;
    eventIndex;
    streamAddress;
    eventType;
    data;
    amount;
    coinType;
    sender;
    executedAt;
    updatedAt;
    createdAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], StreamEvent.prototype, "id", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], StreamEvent.prototype, "txDigest", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], StreamEvent.prototype, "eventIndex", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], StreamEvent.prototype, "streamAddress", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], StreamEvent.prototype, "eventType", void 0);
__decorate([
    Column(getLongTextEntityType()),
    __metadata("design:type", String)
], StreamEvent.prototype, "data", void 0);
__decorate([
    Column('bigint'),
    __metadata("design:type", String)
], StreamEvent.prototype, "amount", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], StreamEvent.prototype, "coinType", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], StreamEvent.prototype, "sender", void 0);
__decorate([
    Column(),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], StreamEvent.prototype, "executedAt", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], StreamEvent.prototype, "updatedAt", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], StreamEvent.prototype, "createdAt", void 0);
StreamEvent = __decorate([
    Entity({ name: 'stream_event' }),
    Unique(['txDigest', 'eventIndex'])
], StreamEvent);
export { StreamEvent };
//# sourceMappingURL=module.js.map